<template>
  <div>
    <div v-if="showSpinner" class="text-center">
      <b-spinner
        :class="spinnerClass"
        style="width: 3rem; height: 3rem; margin-top: 2em;"
        label="Loading..."
      />
    </div>
    <slot v-if="showSlot" />
  </div>
</template>

<script>
  export default {
    name: 'NavigationLoadingWrapper',
    props: {
      loadingBool: {type: Boolean, required: true},
      spinnerClass: {type: String, required: false, default: ''}
    },
    data() {
      return {
        timeoutId: null,
        showSpinner: false,
        showSlot: false
      }
    },
    watch: {
      loadingBool(newIsTrue) {
        window.clearTimeout(this.timeoutId)
        this.timeoutId = null

        if (newIsTrue) {
          this.startSpinnerTimeout()
        } else {
          this.clearSpinner()
        }
      }
    },
    created() {
      if (this.loadingBool) {
        this.startSpinnerTimeout()
      } else {
        this.clearSpinner()
      }
    },
    methods: {
      clearSpinner() {
        this.showSpinner = false
          this.showSlot = true
      },
      startSpinnerTimeout() {
        this.timeoutId = setTimeout(() => {
          this.showSpinner = true
          this.showSlot = false
        }, 200)
      }
    }
  }
</script>
